import { useTranslation } from "react-i18next";

import FullPageMessage from "../../../components/FullPageMessage";

function ScheduledSuccessPage() {
  const LocalBasePath = "page.signUpSuccessfully";
  const { t } = useTranslation("", {
    keyPrefix: LocalBasePath,
  });
  return (
    <FullPageMessage
      body={t("bookingSessionMessage")}
      title={t("sessionBookedSuccessfully")}
    />
  );
}
export default ScheduledSuccessPage;
